import {
  Badge,
} from '@Infowijs-eng/component-library/components'
import { TwoVerticalLines } from '@Infowijs-eng/component-library/icons'
import { Visibility } from '@Infowijs-eng/component-library/modules/authentication'
import { PropTypes } from 'prop-types'
import ImpersonateAsAdminButton from '../ImpersonateAsAdminButton'
import ListItem from '../ListItem'

function CustomerProductListItem({
  to,
  customerProduct,
  customerId,
}) {
  return (
    <ListItem
      className="space-y-1"
      to={to}
      trailingAddon={
        customerProduct.deployedAt !== null && (
          <Visibility permissions="users.customerProductKey.impersonate">
            <ImpersonateAsAdminButton
              customerId={customerId}
              customerProduct={customerProduct}
            />
          </Visibility>
        )
      }
    >
      <div className="text-black font-bold font-display">
        {customerProduct.title}
      </div>
      <div className="flex space-x-1">
        {!customerProduct.deployedAt && (
          <Badge className="bg-red-500" leadingAddon={<TwoVerticalLines />} />
        )}
        <Badge
          className={[
            customerProduct.type === 'hoy' && 'bg-green-500',
            customerProduct.type === 'schoolwiki' && 'bg-blue-500',
            customerProduct.type === 'brugger' && 'bg-red-500',
          ]}
        >
          {customerProduct.type}
        </Badge>
        {customerProduct.premium && (
          <Badge>
            Premium
          </Badge>
        )}
      </div>
      {customerProduct.type === 'hoy' && customerProduct.metadata?.domains && (
        <div className="flex flex-wrap gap-1">
          {customerProduct.metadata.domains.messages && (
            <Badge className="bg-aqua-50 text-aqua-500 text-[10px] leading-3 px-1.5 py-0.5">
              Messages
            </Badge>
          )}
          {customerProduct.metadata.domains.news && (
            <Badge className="bg-orange-50 text-orange-500 text-[10px] leading-3 px-1.5 py-0.5">
              News
            </Badge>
          )}
          {customerProduct.metadata.domains.forms && (
            <Badge className="bg-green-50 text-green-500 text-[10px] leading-3 px-1.5 py-0.5">
              Forms
            </Badge>
          )}
          {customerProduct.metadata.domains.calendar && (
            <Badge className="bg-purple-50 text-purple-500 text-[10px] leading-3 px-1.5 py-0.5">
              Calendar
            </Badge>
          )}
        </div>
      )}
    </ListItem>
  )
}

CustomerProductListItem.propTypes = {
  to: PropTypes.string,
  customerProduct: PropTypes.shape({
    type: PropTypes.string,
    deletedAt: PropTypes.string,
    deployedAt: PropTypes.string,
    title: PropTypes.string,
    premium: PropTypes.bool,
    metadata: PropTypes.shape({
      domains: PropTypes.shape({
        news: PropTypes.bool,
        messages: PropTypes.bool,
        forms: PropTypes.bool,
        calendar: PropTypes.bool,
      }),
    }),
  }),
  customerId: PropTypes.string,
}

CustomerProductListItem.defaultProps = {
  to: null,
  customerProduct: null,
  customerId: null,
}

export default CustomerProductListItem
